import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isInvalidToken:0
}

export const invalidTokenSlice = createSlice({
  name: 'invalidT',
  initialState,
  reducers: {
    setInvalidToken: (state, action) => {
      state.isInvalidToken = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setInvalidToken } = invalidTokenSlice.actions

export default invalidTokenSlice.reducer